import Vue from 'vue'
import configFactory from './common/configFactory'
const sanitizeHtml = require('@/utils/sanitize-html').default

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

// Ensure config is loaded before Vue is init
configFactory().then((config) => {
  // Store config as a global
  Vue.prototype.$config = config

  // Plugins are loaded using require
  const router = require('@router').default
  const store = require('@state/store').default
  const vuetify = require('@plugins/vuetify').default
  require('@plugins/vee-validate')
  require('@plugins/vue-mq')
  require('@plugins/vue-toasted')
  const i18n = require('@plugins/vue-i18n').default
  const signalRHub = require('@plugins/signalr-hub.js').default
  const App = require('./app.vue').default

  // Globally register all `_base`-prefixed components
  require('@components/_globals')

  // Filters
  const truncateText = require('@/filters/truncate-text.js').default
  Vue.filter('truncateText', truncateText)

  // Custom directives
  Vue.directive('sanitized-html', (el, binding) => {
    el.innerHTML = sanitizeHtml(binding.value)
  })

  Vue.use(signalRHub)

  const app = new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
  }).$mount('#app')

  // Handle auth redirect on app load
  store.getters['auth/auth'].handleRedirectPromise().then(async (response) => {
    return await store.dispatch('auth/handleRedirect', response)
  })

  // If running e2e tests...
  if (process.env.VUE_APP_TEST === 'e2e') {
    // Attach the app to the window, which can be useful
    // for manually setting state in Cypress commands
    // such as `cy.logIn()`.
    window.__app__ = app
  }
})
